import { createRouter, createWebHistory } from 'vue-router';
import { BasicLayout } from '@/layout'
const routes = [
    {
        path: '/',
        name: 'app',
        component: BasicLayout,
        meta: { title: '云阙科技' },
        children: [
            { path: '/', component: () => import('@/views/home/home.vue'), },
            { path: '/about', component: () => import('@/views/home/about.vue') },
        ]
    }


];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;